import React from "react";
export default function ScreenWarning() {
    return (
        <div style={{padding: "20px", textAlign: "center"}}>
            <h1>Start this page from a computer</h1>
            <p>Sorry, this career page requires a computer or larger device. Trust us, you'll have a better experience that way.</p>
        </div>
    );
}